import omit from 'lodash/omit'

import { ensureValidData } from '../helpers'
import { FolderData, FolderDataForm } from './types'

export const defaultFolderData: Readonly<FolderData> = {
	name: '',
	diagram: {
		nodes: [],
		links: [],
		zoom: 0,
		offset: {
			x: 0,
			y: 0,
		},
		autoLayoutFlag: true,
	},
	newDiagram: {
		class: '',
		linkKeyProperty: '',
		nodeDataArray: [],
		linkDataArray: [],
	},
	diagramSvg: '',
}

export const getInitialFolderData = (name: string) =>
	ensureValidData(
		{
			name,
		},
		defaultFolderData,
	)

export const getFolderDataForm = (data: FolderData) => {
	const folderDataForm: FolderDataForm = {
		...omit(data, 'namingConfig', 'odcs'),
		generateCode: data.namingConfig?.generateCode,
		generateTableColumnCode: data.namingConfig?.generateTableColumnCode,
		odcsStatus: data.odcs?.status,
		odcsTenant: data.odcs?.tenant,
		odcsPurpose: data.odcs?.purpose,
		odcsUsage: data.odcs?.usage,
		odcsLimitations: data.odcs?.limitations,
	}

	return folderDataForm
}

export const buildFolderOdcsFromForm = (
	form: FolderDataForm,
): FolderData['odcs'] => ({
	tenant: form.odcsTenant,
	purpose: form.odcsPurpose,
	usage: form.odcsUsage,
	limitations: form.odcsLimitations,
})
